import AbstractModule from './AbstractModule';

import { unescapeHtml } from '../utils/html';

export default class extends AbstractModule {
    constructor (options) {
        super(options);

        this.openClass = 'has-election-takeover-open';

        // Intra module events
        this.$el.on('click.ElectionTakeover', '.js-close', (event) => {
            this.toggleElectionTakeover(false);
        });

        // Global events
        this.$document.on('toggle.ElectionTakeover', (event, value) => {
            this.toggleElectionTakeover(value);
        });

        // Prevent feed twitter without deleting it all
        this.$body.addClass(this.openClass);
        return this;

        var _this = this;
        // Ractive instance
        this.controller = new Ractive({
            el: this.$el,
            template: unescapeHtml(this.$el.html()),
            data: {
                activeCategory: '',
                displayTweets: true,
                tweets: [],
                tweetsPerPage: 10,
                page: 1,
                state: 'inert'
            },
            computed: {
                hasMoreTweets: function () {
                    return this.get('page') < this.maxPages();
                },
                columnArray: function () {
                    var tweets = this.get('tweets');
                    var tweetsPerPage = this.get('tweetsPerPage');
                    var columnArray = [];
                    var i = 0;
                    var len = this.get('page');

                    // Sort tweets into pages
                    for (; i < len; i++) {
                        // Determine paging limits
                        let min = tweetsPerPage * i;
                        let max = min + tweetsPerPage;
                        let pagedTweets = tweets.slice(min, max);

                        // Sort tweets into columns
                        let columns = {
                            leftColumn: [],
                            rightColumn: []
                        };
                        let j = 0;
                        let tweetCount = pagedTweets.length;

                        for (; j < tweetCount; j++) {
                            // If `is even`. Increment by 1 to have proper remainder testing
                            if ((j + 1) % 2 === 0) {
                                columns.rightColumn.push(pagedTweets[j])
                            } else {
                                columns.leftColumn.push(pagedTweets[j])
                            }
                        }

                        columnArray[i] = columns;
                    }
                    return columnArray;
                },
                pageArray: function () {
                    var tweets = this.get('tweets');
                    var tweetsPerPage = this.get('tweetsPerPage');
                    var pageArray = [];
                    var i = 0;
                    var len = this.get('page');
                    for (; i < len; i++) {
                        let min = tweetsPerPage * i;
                        let max = min + tweetsPerPage;
                        let page = tweets.slice(min, max);
                        pageArray.push({
                            tweets: page
                        });
                    }
                    return pageArray;
                }
            },
            delimiters: [ '[[', ']]' ],
            tripleDelimiters: [ '[[[', ']]]' ],
            /**
             * Calculate the max pages possible.
             * @return {int}
             */
            maxPages: function() {
                var tweetCount = this.get('tweets').length;
                var tweetsPerPage = this.get('tweetsPerPage');
                var remainder = (tweetCount % tweetsPerPage);
                return (tweetCount - remainder) / tweetsPerPage + (remainder !== 0 ? 1 : 0);
            },
            /**
             * Allows us to set proxy events and run other tasks when controller is initialized
             * @param  {array}  options  Array of options
             */
            oninit: function(options) {
                this.on({
                    /**
                     * Fired by the load more button
                     */
                    loadNextPage: function() {
                        this.add('page');
                    },
                    /**
                     * Update the election feed
                     */
                    updateFeed: function() {
                        _this.invokeFetchQuery((response) => {
                            this.set('tweets', response.tweets);
                        })
                    }
                });

                _this.$body.addClass(_this.openClass);
                this.fire('updateFeed');
            }
        });

        this.interval = window.setInterval(() => {
            this.controller.fire('updateFeed');
        }, 30000);
    }

    /**
     * Query server for election feed and send them to the callback function
     * @param  {function}  callback  Function to execute after the AJAX request is done
     */
    invokeFetchQuery(callback) {
        // Default response
        var _response = {
            tweets: []
        };

        var jqxhr = $.ajax({
            method : 'GET',
            type: 'json',
            dataType: 'json',
            url    : 'fetch-election-feed'
        })
        .done((response) => {
            if (response.success === true) {
                _response = response;
            }
        })
        .fail(() => {
            console.log('error');
        })
        .always(() => {
            callback(_response);
        });
    }

    /**
     * Toggles class on body that determines if election takeover is visible or not.
     * @param  boolean|mixed  State
     */
    toggleElectionTakeover(state) {
        if (typeof state !== 'undefined' && typeof state === 'boolean') {
            this.$body.toggleClass(this.openClass, state);
        } else {
            this.$body.toggleClass(this.openClass);
        }
    }

    destroy() {
        // window.clearInterval(this.interval);

        // this.controller.teardown();
        this.$el.off('.ElectionTakeover');
        this.$body.removeClass(this.openClass);
    }
}
